'use client';

import { type BunkerEquipCardType, type BunkerInventoryItemType, bunkerEquipData, bunkerInventoryData } from '@/components/Bunker/data';
import { type PropsWithChildren, createContext, useContext, useState } from 'react';
export type BunkerContextProps = {
  selectedPart: BunkerEquipCardType;
  setSelectedPart: (selected: BunkerEquipCardType) => void;
  active: BunkerInventoryItemType;
  setActive: (item: BunkerInventoryItemType) => void;
  success: boolean;
  setSuccess: (isSuccess: boolean) => void;
};
const BunkerContext = createContext<BunkerContextProps | null>(null);
export const BunkerProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [selectedPart, setSelectedPart] = useState<BunkerEquipCardType>(bunkerEquipData[0]);
  const [active, setActive] = useState<BunkerInventoryItemType>(bunkerInventoryData[2]);
  const [success, setSuccess] = useState<boolean>(true);
  return <BunkerContext.Provider value={{
    selectedPart,
    active,
    setSelectedPart,
    setActive,
    success,
    setSuccess
  }}>
      {children}
    </BunkerContext.Provider>;
};
export const useBunker = () => {
  const context = useContext(BunkerContext);
  if (!context) {
    throw new Error('useBunker must be used within a BunkerProvider');
  }
  return context;
};